<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 15:04:25
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchCriteriaType\PunchCriteriaType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_punchCriteriaType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-clock-in-criteria')"
    @new="mapToDialog = true"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.icon="{ item }">
          <v-img
            :src="item.attachments[0]['url']"
            aspect-ratio="1"
            v-if="item.attachments.length"
            max-width="60"
            max-height="60"
            class="grey lighten-2 ma-2 ml-0 pl-0"
          />
        </template>
        <template v-slot:item.name="{ item }">
          <div class="balck--text table-title">
            {{ $getCommonLangValue(item.criteria_type_name) }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.criteria_type_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">{{
          $getCommonLangValue(item.criteria_type_abbr)
        }}</template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-clock-in-criteria')"
            :editBtn="hasBtn('edit-admin-clock-in-criteria')"
            editText="message_essweb_list_components_tools_editBtnTip"
            :viewBtn="hasBtn('view-admin-clock-in-criteria')"
            :title="$t('label_essweb_punchCriteriaType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toView"
          />
        </template>
      </Tabler>
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <newMappingDialog
        :show="mapToDialog"
        @onNewProperty="onNew"
        @close="mapToDialog = false"
        on
      />
      <editMappingDialog
        :show="mapToEditDialog"
        :showAction="showAction"
        :CurDataUuid="CurDataUuid"
        @onEditProperty="onEdit"
        @close="
          mapToEditDialog = false;
          CurDataUuid = null;
        "
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import newMappingDialog from "@/Page/EssAdmin/Punch/PunchCriteriaType/components/newMapping";
import editMappingDialog from "@/Page/EssAdmin/Punch/PunchCriteriaType/components/editMapping";
import { mapGetters } from "vuex";
export default {
  name: "punchCriteriaType",
  components: { newMappingDialog, editMappingDialog },
  computed: {},
  data() {
    return {
      showSelect: false,
      search: "",
      showAction: null,
      selected: [],
      totalCount: 0,
      mapToDialog: false,
      mapToEditDialog: false,
      CurDataUuid: null,
      headers: [
        // 2021-04-25 删掉图标 brain
        // {
        //   text: "label_essweb_punchCriteriaType_list_iconLabel",
        //   value: "icon",
        //   align: "start",
        //   sortable: false,
        // },
        {
          text: "label_essweb_punchCriteriaType_list_cirteriaLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchCriteriaType_list_abbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_type",
        url: "/criteria-type/get-criteria-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toEdit: function (uuid) {
      this.showAction = "edit";
      this.CurDataUuid = uuid;
      this.mapToEditDialog = true;
    },
    toView: function (uuid) {
      this.showAction = "view";
      this.CurDataUuid = uuid;
      this.mapToEditDialog = true;
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_type",
        url: "/criteria-type/delete-criteria-type-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_punchCriteriaType_list_deleteCriteriaTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    onEdit: function (obj) {
      const that = this;
      that.mapToEditDialog = false;
      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_type",
        url: "/criteria-type/update-criteria-type-table/",
        data: {
          uuid: obj.uuid,
          criteria_type_name: this.$transCommonLangKey(
            obj.criteria_type_name,
            obj.criteria_type_name_save
          ),
          criteria_type_description: this.$transCommonLangKey(
            obj.criteria_type_description,
            obj.criteria_type_description_save
          ),
          criteria_type_abbr: this.$transCommonLangKey(
            obj.criteria_type_abbr,
            obj.criteria_type_abbr_save
          ),
          // table_name: obj.table_name,//非法操作，2020-08-31改为不传
          // view_name: obj.view_name,
          // container_name: obj.container_name,
          // attachment_uuid: obj.attachment_uuid["uuid"], //2020-11.2 BJ icon->attachment_uuid
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getList();
      });
    },
    onNew: function (obj) {
      const that = this;

      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_type",
        url: "/criteria-type/add-criteria-type-table/",
        data: {
          punch_code: obj.punch_code,
          criteria_type_name: this.$transCommonLangKey(obj.criteria_type_name),
          criteria_type_description: this.$transCommonLangKey(
            obj.criteria_type_description
          ),
          criteria_type_abbr: this.$transCommonLangKey(obj.criteria_type_abbr),
          table_name: obj.table_name,
          // view_name: obj.view_name,
          // container_name: obj.container_name,
          // attachment_uuid: obj.attachment_uuid["uuid"], //2020-11.2 BJ icon->attachment_uuid
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getList();
        that.mapToDialog = false;
      });
    },
  },
};
</script>
